import React from "react";

export const WarningWrapper = ({ children }: { children: React.ReactNode }) => (
  <div
    className="dark:bg-primary dark:border-primary rounded-xl border border-amber-200 bg-amber-100 p-6"
    data-testid="plan-cancelled"
  >
    {children}
  </div>
);
